import { IProduct, IProductCategory } from "../../types/Product";

/**
 * The filter function returned will:
 *
 * If searchTerm is empty, returns true.
 * If searchTerm is not empty, then it will check all products in every category:
 *   - if category has no products, returns false
 *   - if category has no products that match searchParam, returns false.
 *   - if category has at least one product that matches searchParam, returns true.
 *
 * Ps: true means the category is included, false means the category will be filtered out.
 * @param searchTerm
 * @returns a function that filters categories according to above.
 */
function filterCategoriesWithNoProductsInSearchResult(searchTerm: string) {
  return (category: IProductCategory) => {
    if (searchTerm === "") return true;

    for (const produto of category.data) {
      if (produto.name
        .toLowerCase()
        .includes(searchTerm.toLowerCase())) {
        return true;
      }
    }

    return false;
  };
}

/**
 *
 * @param searchTerm
 * @returns a function that filters products according to searchTerm
 */
function filterProductsBySearch(searchTerm: string) {
  return (product: IProduct) =>
    searchTerm === ""
    || product.name
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
}

const filterCategoriesOnlyNonTrend =
  (category: IProductCategory) => category.title !== "Destaques e Promoções";

const filterCategoriesOnlyTrend =
  (category: IProductCategory) => category.title === "Destaques e Promoções";

export {
  filterCategoriesWithNoProductsInSearchResult,
  filterCategoriesOnlyNonTrend,
  filterCategoriesOnlyTrend,
  filterProductsBySearch,
};